import React from 'react';
import { FileText } from 'lucide-react';
import { DropzoneRootProps, DropzoneInputProps } from 'react-dropzone';

interface InvoiceUploaderProps {
  getRootProps: (props?: any) => DropzoneRootProps;
  getInputProps: (props?: any) => DropzoneInputProps;
  isDragActive: boolean;
}

export default function InvoiceUploader({
  getRootProps,
  getInputProps,
  isDragActive
}: InvoiceUploaderProps) {
  return (
    <div
      {...getRootProps()}
      className={`border-2 border-dashed border-gray-800 rounded-lg p-8 transition-colors ${
        isDragActive ? 'border-indigo-500 bg-indigo-500/10' : ''
      }`}
    >
      <div className="text-center">
        <FileText className="mx-auto h-12 w-12 text-[#86868b]" />
        <input {...getInputProps()} />
        <div className="mt-4">
          <p className="text-sm font-medium text-[#c8c2bd]">
            {isDragActive
              ? 'Drop the PDF invoices here...'
              : 'Drag & drop PDF invoices here, or click to select files'}
          </p>
          <p className="mt-1 text-xs text-[#86868b]">
            You can upload multiple invoices at once
          </p>
        </div>
      </div>
    </div>
  );
}